"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMultiField = void 0;
var lodash_1 = require("lodash");
var isMultiField = function (field) {
  return (0, lodash_1.includes)(['linkedTable', 'linkedMultiple', 'permissions'], field === null || field === void 0 ? void 0 : field.type);
};
exports.isMultiField = isMultiField;